import { lazy, Suspense, useEffect, useRef, useState } from "react";

const SimpleMap = lazy(() => import("./Map"));

export default function LazyMap() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ width: "100%", height: "35vh" }}>
      {visible && (
        <Suspense fallback={null}>
          <SimpleMap />
        </Suspense>
      )}
    </div>
  );
}
